module.exports = __webpack_public_path__ + "img/Instagram.ac14e02f.png";